import en from './en_US'
import zh_cn from './zh_CN.js'
import zh_tw from './zh_TW.js'
import ru_ru from './ru_RU.js'

export default {
  en,
  zh_cn,
  zh_tw,
  ru_ru,
}